import { usePageTracking } from '../hooks/usePageTracking';

// Component that handles analytics tracking
// Wrap your routes with this component
const AnalyticsProvider = ({ children }) => {
  usePageTracking();
  return children;
};

export default AnalyticsProvider;
